<script setup>
import SmartDisplayC from '@rebuild/components/SmartDisplayC.vue';
import { usePureModule } from '@rebuild/hooks/usePureModule';

const { isMobile, activeModule, getModuleId, getModuleProps } = usePureModule();
</script>

<template>
	<!-- 原 /qme 访问模式 -->
	<div class="clear-component-frame">
		<SmartDisplayC
			:compId="getModuleId(activeModule)"
			:mode="isMobile ? 'mob-full' : 'full'"
			v-bind="getModuleProps(activeModule)"
		/>
	</div>
</template>

<style lang="less" scoped></style>
